import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Surveys_ds_survey_grid_input_values_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { values: { header1?: string, header2?: string, header3?: string, header4?: string, header5?: string }[], $top?: number, $skip?: number }): Promise<{ result?: { Header1?: string, Header2?: string, Header3?: string, Header4?: string, Header5?: string }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.values)) {
      missingRequiredInParams.push('\'values\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Surveys/datasources/ds_survey_grid_input_values_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { values?: { header1?: string, header2?: string, header3?: string, header4?: string, header5?: string }[], $keys: string[] }): Promise<{ result?: { Header1?: string, Header2?: string, Header3?: string, Header4?: string, Header5?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Surveys/datasources/ds_survey_grid_input_values_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      values: { header1?: string, header2?: string, header3?: string, header4?: string, header5?: string }[]    }) {
        if(isNil(inParams.values)) {
          return true; 
        }
      return false;
    }
}
